import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import { IRatingData } from "../ratings/get-ratings.handler";
import getAssetsHandler from "./get-assets.handler";

export interface IAssetsState extends IRequestState {
    ratings: IRatingData[];
    collectionsCount: number;
    boostsCount: number;
    achievementsCount: number;
};

const initialState: IAssetsState = {
    ratings: [],
    collectionsCount: 0,
    boostsCount: 0,
    achievementsCount: 0,

    loading: false,
    error: "",
};

const assetsSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {},
    extraReducers: (builder: ActionReducerMapBuilder<IAssetsState>) => {
        getAssetsHandler(builder);
    },
});

export default assetsSlice.reducer;